:host {
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding: 30px;
}

ux-icon {
    font-size: 60px;
}

.headline,
.text {
    font-family: Frutiger-Light, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizelegibility;
    font-weight: 400;
}

.headline {
    font-size: 20px;
    margin-top: 20px;

    @media only screen and (width >= 1439px) {
        font-size: 23px;
    }

    @media only screen and (width >= 1920px) {
        font-size: 28px;
    }
}

.text {
    color: #727272;
}
